// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"styles_btnWrap__ozbwy","isPro":"styles_isPro__kmBUD","blogBtn":"styles_blogBtn__xqE0B","defaultColor":"styles_defaultColor__j_7ef"};